import { render } from "./ImageModal.vue?vue&type=template&id=04a12ef2&scoped=true&ts=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=04a12ef2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a12ef2"]])

export default __exports__